import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

const LoadingScreen = () => {
    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                backgroundColor: '#050505',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
        >
            {/* Background Atmosphere */}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100vw',
                height: '100vh',
                background: 'radial-gradient(circle, rgba(188, 19, 254, 0.05) 0%, transparent 70%)',
                zIndex: -1
            }} />

            {/* Pulsing Logo */}
            <motion.div
                animate={{
                    scale: [1, 1.05, 1],
                    filter: [
                        'drop-shadow(0 0 20px rgba(0, 243, 255, 0.3))',
                        'drop-shadow(0 0 40px rgba(0, 243, 255, 0.6))',
                        'drop-shadow(0 0 20px rgba(0, 243, 255, 0.3))'
                    ]
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                className="mb-5 position-relative"
            >
                <img src={logo} alt="Loading..." style={{ width: '120px' }} />

                {/* Orbiting Ring */}
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                    style={{
                        position: 'absolute',
                        top: '-20px', left: '-20px', right: '-20px', bottom: '-20px',
                        border: '1px solid transparent',
                        borderTop: '2px solid var(--neon-cyan)',
                        borderBottom: '2px solid var(--neon-pink)',
                        borderRadius: '50%',
                        boxShadow: '0 0 15px rgba(0, 243, 255, 0.2)'
                    }}
                />
            </motion.div>

            {/* Loading Text */}
            <div className="text-center">
                <motion.h4
                    animate={{ opacity: [0.5, 1, 0.5] }}
                    transition={{ duration: 1.5, repeat: Infinity }}
                    className="text-white mb-3"
                    style={{
                        fontFamily: 'Orbitron, sans-serif',
                        letterSpacing: '4px',
                        fontSize: '1.2rem'
                    }}
                >
                    INITIALIZING <span className="text-neon-cyan">SYSTEM</span>
                </motion.h4>

                {/* Progress Bar */}
                <div style={{
                    width: '300px',
                    height: '4px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '2px'
                }}>
                    <motion.div
                        initial={{ x: '-100%' }}
                        animate={{ x: '0%' }}
                        transition={{
                            duration: 2.5,
                            ease: "easeInOut",
                            repeat: Infinity,
                            repeatType: "loop",
                            repeatDelay: 0.5
                        }}
                        style={{
                            width: '100%',
                            height: '100%',
                            background: 'linear-gradient(90deg, transparent, var(--neon-cyan), var(--neon-pink))',
                            boxShadow: '0 0 20px var(--neon-cyan)'
                        }}
                    />
                </div>

                <p className="mt-3 text-secondary small tracking-widest" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                    ESTABLISHING SECURE CONNECTION_
                </p>
            </div>
        </motion.div>
    );
};

export default LoadingScreen;
